import React from "react";

import SectionHome from "../components/SectionHome";

function HomeView() {
  return (<SectionHome />);
}

export default HomeView;
